import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import EnvelopDetail from '../../components/envelop/EnvelopDetail';

import { translate } from 'react-i18next';
import { defaultRejectHandler } from '../../utils/utility';
import { createEnvelop } from '../../redux/envelop/envelop_actions';

class EnvelopCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.envelopDetail = undefined;
  }

  onSaveHandler() {
    const newEnvelop = this.envelopDetail.getWrappedInstance().getWrappedInstance().getEnvelopData();
    this.props.createEnvelop(newEnvelop);
  }

  render() {
    const { isCreating, errorMessage, createEnvelop, zone, building, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create envelop')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EnvelopDetail
            envelop={zone && { zone_id: zone.id, zone_name: zone.name }}
            building={building}
            ref={ref => (this.envelopDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="envelop-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.envelop.errorMessage,
  isCreating: state.envelop.isCreating,
});

const mapDispatchToProps = (dispatch, props) => ({
  createEnvelop: env =>
    defaultRejectHandler(
      dispatch(
        createEnvelop(env.name, env.zone_id, env.azimuth_angle, env.inclination, env.description, env.type, props.building.id)),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EnvelopCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/envelop/EnvelopCreateModal.js